import React from 'react';
import { SectionHeading } from '../../../../components/SectionHeading';
import { Typography } from '../../../../wag-react/components/Typography';
import { Box } from '../../../../wag-react/next-components/box';
export const WellnessTopHeadingsContainer = () => <Box data-sentry-element="Box" data-sentry-component="WellnessTopHeadingsContainer" data-sentry-source-file="index.tsx">
    <SectionHeading mx="8px" mt={['16px', '24px']} data-sentry-element="SectionHeading" data-sentry-source-file="index.tsx">
      Peace of mind for your pet’s wellness
    </SectionHeading>
    <Typography textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      Wag! Wellness covers your pet’s routine healthcare needs.
    </Typography>
  </Box>;